'use client';

import { cn } from '@eliadmin/core/src/utils/style-utils';
import Image from '@eliadmin/core/src/components/image/image-wrapped';
import { Heading } from '../ui/heading';
import { Paragraph } from '../ui/paragraph';
import { ContactForm } from '@eliadmin/core/src/components/contact/contact-form';

interface ContactCardProps {
  className?: {
    section?: string;
    container?: string;
  };
}

export function Contact({ className }: ContactCardProps) {
  return (
    <section className={cn('custom-section', className?.section)}>
      <div
        className={cn(
          'custom-container',
          'flex flex-col items-start justify-start md:flex-row md:items-stretch md:justify-between',
        )}
      >
        <Image
          src={'/images/contact.jpg'}
          alt={'Kontakt'}
          width={0}
          height={0}
          className="h-[200px] w-full object-cover object-center sm:h-[330px] md:h-auto md:max-w-[486px]"
          sizes="100vw"
        />
        <div className="flex w-full flex-col items-start justify-start gap-6 border border-l border-y-border border-l-border border-r-border px-4 py-8 sm:py-10 md:max-w-[714px] md:border-l-0 lg:px-6 lg:py-12 xl:px-12">
          <div className="flex w-full flex-col items-start justify-start gap-4">
            <Heading title="Spojte sa s nami" />
            <Paragraph color="muted-foreground" className="w-full">
              Vyplňte formulár a my sa vám ozveme.
            </Paragraph>
          </div>
          <ContactForm />
        </div>
      </div>
    </section>
  );
}
